import ApiGet from "../../../../../../api-controller-mod/api-serv/get-api/getApi";
import ApiGetRealtime from "../../../../../../api-controller-mod/api-serv/get-api/getApiRealtime";
import { API_ENDPOINTS } from "../../../../../../context-controller-mod/context-serv/global-provider/api-shell/api-provider";

export interface ApiNotificationMessage {
  module: string;
  message: string;
}

export interface ApiNotificationItem {
  id: string;
  status: string;
  readStatus: string;
  message: string | ApiNotificationMessage;  // raw string or parsed object
  requesterId: string;
  approverId: string;
  createdAt: string;
  [key: string]: unknown;
}

export type NotificationApiResponse = {
  success?: boolean;
  data?: ApiNotificationItem[] | { items?: ApiNotificationItem[] };
  items?: ApiNotificationItem[];
};

/* ── Fetch ───────────────────────────────────────────────── */
 /* istanbul ignore next */
export const getNotificationsApi = () =>
  ApiGet<NotificationApiResponse>(`${API_ENDPOINTS.GET_ALL_NOTIFICATIONS}?page=1&size=10`);

/* ── SSE ─────────────────────────────────────────────────── */
 /* istanbul ignore next */
export const subscribeNotificationSSE = (
  onMessage: (item: ApiNotificationItem) => void,
  onError?: (e: unknown) => void,
): () => void =>
   /* istanbul ignore next */
  ApiGetRealtime(
    API_ENDPOINTS.REAL_TIME_NOTIFICATION,
    'notification',
    (data) => onMessage(data as ApiNotificationItem),
    onError,
);